import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from 'components/shared/LoaderMain';

const SkeletonTransferBook: FC = () => {
    return (
  <>
      <div className="transfer-results-data">
        <div className="book-form default-shadow mb-15">
          <div className="title-underline text-lg mb-20">
            <Skeleton width={200} height={20} />
          </div>
          <span className="mr-5">
            <Skeleton width={200} />
          </span>
          <div className="form-wrapper row">
            <div className="col-md-6 col-12">
              <Skeleton width={140} className="mb-5" />
              <Skeleton width={'100%'} height={38} className="mb-20" />
            </div>
            <div className="col-md-6 col-12">
              <Skeleton width={140} className="mb-5" />
              <Skeleton width={'100%'} height={38} className="mb-20" />
            </div>
            <div className="col-md-6 col-12">
              <Skeleton width={140} className="mb-5" />
              <Skeleton width={'100%'} height={38} className="mb-20" />
            </div>
            <div className="col-md-6 col-12">
              <Skeleton width={140} className="mb-5" />
              <Skeleton width={'100%'} height={38} className="mb-20" />
            </div>
            <div className="col-12">
              <Skeleton width={140} className="mb-5" />
              <Skeleton width={'100%'} height={38} className="mb-20" />
            </div>
          </div>
        </div>
        <div className="flex-row-end">
          <Skeleton width={160} height={42.5} />
        </div>
      </div>
      <div className="transfer-results-info">
        <div className="default-shadow transfer-sum">
          <div className="title-underline text-md">
            <Skeleton height={24} width={120} />
          </div>
          <div className="h200px w100p">
            <Skeleton height={'100%'} />
          </div>
        </div>
        <div className="default-shadow transfer-sum">
          <div className="title-underline text-md">
            <Skeleton height={24} width={120} />
          </div>
          <div>
            <Skeleton height={18} width={'50%'} className="mb-10" />
            <Skeleton height={18} width={'30%'} className="mb-5" />
            <Skeleton height={18} width={'50%'} className="mb-5" />
            <Skeleton height={18} width={'70%'} className="mb-5" />
            <Skeleton height={18} width={'80%'} className="mb-5" />
            <Skeleton height={18} width={'80%'} className="mb-20" />
            <span className="text-center">
              <Skeleton height={30} width={'50%'} style={{ marginInlineStart: '25%' }} />
            </span>
          </div>
        </div>
      </div>
      <LoaderMain systemProducts="Transfers" systemProductsDetails="LoadingBook" />
  </>
  );
};

export default SkeletonTransferBook;
